const environment = {
  guestyApi: 'https://app.guesty.com/api/v2',
  guestyApi2: 'https://groot-mailer.production.guesty.com/api/v2',
  pordalApi: 'https://o-api.pordal.com',
  pordalNodeApi: 'https://pordal-api.prod.frankportertech.com/api/v1',
  pordalAdminApi: 'https://a-api.pordal.com',
  pordalAdminUser: 'arjun-solanki',
  pordalAdminPassword: 'hS!.QF0{p,0bX{Y5b$F,bUXAbh)CKa',
  ownerApi: 'https://panel.frankporter.com/owner/api/owner_api',
  frankPorterApi: 'https://panel.frankporter.com',
  apiKey: 'KdDnXIZcVp0HBF2pzzVDHvNqE0CwxVnp',
  guestyApiKey: '957764c55f336af66b31bc12d7a3b7ad',
  guestyApiSecret: '36cb292533280c2790b2fe9ca419b49f',
  apiUsername: 'FP-Owner',
  apiPassword: 'QXGF4Zr84QoP)fRZa',
  accountId: '5b686412cdbb89003d8323b6',
  timeFormat: 'hh:mm A',
  timeFormatRU: 'HH:mm',
  pageSize: 999,
  isSentryEnabled: true,
  sentryDsn: 'https://4aeb2014c4ce4a02b3db371b5744555a@o1068165.ingest.sentry.io/6389075',
  sentrySampleRate: 0.1,
  pordalAppClient: 't35tcl13nt',
  appStoreId: '1491310447',
  androidPackageName: 'com.euvic.fpowner',
};

export default environment;
